module.exports = __webpack_public_path__ + "static/img/qiye.64c13ed7.png";